import * as actionTypes from '../actions/action-types';
import MarketingPreferenceType from '../../enums/MarketingPreferenceType';

const getInitialState = () => {
  const siteData = window.start.siteDataV2;
  const noMarketingPreselection = window.start.settings.no_marketing_preselection;
  const preselectMarketingTrue = window.start.settings?.preselect_marketing_true;
  const experiments = siteData && siteData.clientExperiments;
  const marketingExperiment = experiments && experiments.guest_checkout_marketingOptIn_wave_01;
  const isInMarketingExperiment = marketingExperiment && marketingExperiment === 'v1|noPreselection';
  
  return ({
    emailAddress: '',
    optedIntoMarketing: (isInMarketingExperiment || noMarketingPreselection) ? null : !!preselectMarketingTrue, // Opted out by default. If in experiment, no preselection.
    showMarketingPreferences: MarketingPreferenceType.NONE,
  });
};

const emailReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case actionTypes.UPDATE_EMAIL_ADDRESS:
      return {...state, emailAddress: action.emailAddress};
    case actionTypes.SET_MARKETING_PREFERENCE:
      return {...state, optedIntoMarketing: action.optedIntoMarketing};
    case actionTypes.SET_SHOW_MARKETING_PREFERENCE:
      return {...state, showMarketingPreferences: action.displayType};
    
    default:
      return state;
  }
};

export default emailReducer;
